import React from "react"

import { HtmlHeadingTag } from "../title"
import * as styles from "./index.module.scss"

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  as: HtmlHeadingTag | "p" | "span"
}

function Subtitle({ as, className, ...rest }: Props) {
  const Element = as

  return <Element className={`${styles.subtitle} ${className}`} {...rest} />
}

export default Subtitle
